import { Component, OnInit } from '@angular/core';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { TransferStoreFacade } from '../../../common/facade/TransferStoreFacade';
import { ActivatedRoute, Router, NavigationExtras, Navigation } from '@angular/router';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { TransferStoreEntryDetail } from '../../../common/model/TransferStoreEntryDetail';

@Component({
    selector: 'app-transfer-store-entry-detail',
    templateUrl: './transfer-store-entry-detail.component.html',
    styleUrls: ['./transfer-store-entry-detail.component.css']
})
export class TransferStoreEntryDetailComponent implements OnInit {
  titleTransfer = res.Transfer;
    
  
  lblDownload = res.Download;
  lblSelectAnOption = res.SelectAnOption;
    lblSearch = res.Search;
    lblOrigin = res.Origin;
    lblDestination = res.Destination;
 
  lblInvoice = res.TransferStoreEntry;

    lblStyleVariety = res.StyleVariety;
    lblDescrip = res.Description;
    lblSizeName = res.Size;
    lblQuantity = res.Quantity;
    folioTransferEntryTitle = res.FolioTransferEntryTitle;
  
  isSpanish = true;
  language = 0;

  messagesTable : any = {
    emptyMessage: "",
    totalMessage: "" 
  }

  loading = false;
  messageLoader = '';
  // alert
  alerts = [];
  // info Header
  storeOriginName = '';
  storeDestinyName = '';
  // Filtros
  gender = '-1';
  genders = [];
  style = '-1';
  styles = [];

    rows: TransferStoreEntryDetail[] = [];
    private _filteredData: TransferStoreEntryDetail[] = [];

    transferReqId = '';
    invoiceEntry = '';


    constructor(
        private _router: Router,
        private _excel: ExcelUtility,
        private _transferStoreFacade: TransferStoreFacade,
        private _activatedRoute: ActivatedRoute,
        public strings: Strings
    ) {
        let nav: Navigation = this._router.getCurrentNavigation();

        if (nav.extras && nav.extras.state) {
            this.storeOriginName = nav.extras.state.origin;
            this.storeDestinyName = nav.extras.state.destiny;
            this.transferReqId = nav.extras.state.idTranfer;
        }  
        
    }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1
      }

    this.getTransferEntryDetail();
  }

  private getTransferEntryDetail() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
      const id = this._activatedRoute.snapshot.paramMap.get('id');
      this.invoiceEntry = id;
      this._transferStoreFacade.GetTransferStoreEntryDetail(id).subscribe(
      response => {
        this.loading = false;
        this.rows = response.data;
        this._filteredData = response.data;
        this.gender = '-1';
        this.style = '-1';        
        
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheTransfersCouldNotBeObtained), 'danger');
      }
    );
    }

    // Filtros
     updateFilter(event) {
        // get the value of the key pressed and make it lowercase
        const val = event.target.value.toLowerCase();
        // get the key names of each column in the dataset
        const keys = Object.keys(this._filteredData[0]);
        // assign filtered matches to the active datatable
        this.rows = this._filteredData.filter(function (item) {
            // iterate through each row's column data
            for (let i = 0; i < keys.length; i++) {
                if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                    return true;
                }
            }
        });
    }       

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  // Save excel
  downloadLayout() {
     if (this.rows.length > 0) {
       const data: any = [];
       this.rows.forEach(row => {
           const info = {
               [this.strings.GetText(res.StyleVariety)]: row.styleVariety,
               [this.strings.GetText(res.Description)]: row.description,
               [this.strings.GetText(res.Size)]: row.sizeName,
               [this.strings.GetText(res.Quantity)]: row.quantity
           };
         data.push(info);
       });
         this._excel.exportAsExcelFile(data, this.strings.GetText(res.FolioTransferEntryTitle) + ' - ' + this.invoiceEntry);
     } else {
       this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger');
     }
  }

}
